import * as queryString from 'query-string';
import useRouter from 'use-react-router';
import { isAutomationKind, UIFilterAutomationRuleKindType } from './types';

const parseKind = (search: string): UIFilterAutomationRuleKindType => {
  const { kind } = queryString.parse(search);
  return isAutomationKind(kind) ? kind : 'system_messages';
};

export const useAutomationRulesFilter = () => {
  const { history, location } = useRouter();
  const { search } = location;
  const activeKind = parseKind(search);

  const setSearchParams = (params: Record<string, any>) => {
    const searchParams = queryString.parse(search);
    history.push({
      ...location,
      search: queryString.stringify({ ...searchParams, ...params }),
    });
  };

  const setFilterKind = (kind?: UIFilterAutomationRuleKindType) =>
    setSearchParams({ kind });

  return {
    activeKind,
    setFilterKind,
  };
};
